import { InputAdornment, InputLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';
import { numericality, combine } from 'redux-form-validators';
import { TextField } from 'src/shared/components/Form/TextField';
import { showErrorOnChange } from 'src/shared/components/Form/Util';
import { requireIfAnyUsed, totalLimitValidator } from './customValidators';
import { useField } from 'react-final-form';

type FieldProps = {
  fieldMaxLimit: number;
  fieldName: string;
  totalLimit: number;
  currencySymbol: string;
  inputLabel: string;
};

const LimitField = ({ fieldMaxLimit, fieldName, totalLimit, currencySymbol, inputLabel }: FieldProps) => {
  const classes = useStyles();
  const { t } = useTranslation(['flexflow', 'form']);
  const invalidField = useField(fieldName);

  return (
    <>
      <TextField
        label={inputLabel}
        placeholder="-"
        fieldProps={{
          validate: combine(
            totalLimitValidator({
              total: totalLimit
            }),
            requireIfAnyUsed({
              errorMsg: t('error.required if other limits')
            }),
            numericality({
              int: false,
              '<=': fieldMaxLimit,
              allowBlank: true,
              msg: t('messages.field value must be less than or equal to', {
                ns: ['form'],
                amount: `{count, number} ${currencySymbol}`
              }).toString()
            })
          )
        }}
        showError={showErrorOnChange}
        type="number"
        className={classes.disableShadowInputDom}
        name={fieldName}
        InputProps={{
          style: { marginBottom: '0.2rem' },
          startAdornment: <InputAdornment position="start">{currencySymbol}</InputAdornment>
        }}
        FormHelperTextProps={{
          classes: {
            root: classes.helperTextRoot
          }
        }}
      />
    </>
  );
};

export default LimitField;
